import { AppQuestionData } from './app-question-data';

export class SectionData {
    private properties: any = {};
    private resume: Array<any> = [];
    private appQuestionData: AppQuestionData[] = [];
    private showSmsDialog: boolean;

    constructor() {}
    
    SetProperty(prop: string, value: any) {
        this.properties[prop] = value;
    };

    GetProperty(prop: string): any {
        return this.properties[prop];
    };

    GetAll() {
        return this.properties;
    }

    SetAllProperties(obj: object) {
        Object.keys(obj).forEach(prop => {
            this.properties[prop] = obj[prop];
        });
    }

    SetResume(resume: Map<number, string>) {
        this.resume = Array.from(resume);
    }

    GetResume(): Map<number, string> {
        return new Map(this.resume);
    }

    SetAppQuestionData(questions: AppQuestionData[]) {
        this.appQuestionData = questions;
    }

    GetAppQuestionData(): AppQuestionData[] {
        return this.appQuestionData;
    }

    IsEmpty() {
        return this.properties === null || this.properties && Object.keys(this.properties).length === 0;
    }

    GetSmsDialog(): boolean {
        return this.showSmsDialog;
    }

    SetSmsDialog(value: boolean) {
        this.showSmsDialog = value;
    }
}